import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EstadoDocumentoItem, EstadoSolicitudItem, SolicitudSeccion } from 'src/app/models/common/enumModel';
import { ISolicitudEquipoValidarModel } from 'src/app/models/interfaces/solicitud/equipos/ISolicitudEquipoValidarModel';
import { ISolicitudEquipoModel } from 'src/app/models/interfaces/solicitud/ISolicitudEquipoModel';
import { DocumentacionRequeridaModel } from 'src/app/models/solicitud/DocumentacionRequeridaModel';
import { SolicitudDocumentoModel } from 'src/app/models/solicitud/documento/SolicitudDocumentoModel';
import { EquipoModel } from 'src/app/models/solicitud/EquipoModel';
import { SolicitudEquipoValidarModel } from 'src/app/models/solicitud/equipos/SolicitudEquipoValidarModel';
import { SolicitudEquipoService } from 'src/app/services/solicitud-equipo/solicitud-equipo.service';
import * as fileSaver from 'file-saver';
import { SolicitudEquipoDocumentosService } from 'src/app/services/solicitud-equipo-documentos/solicitud-equipo-documentos.service';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { VisorPdfDialogComponent } from 'src/app/components/shared/visor-pdf-dialog/visor-pdf-dialog.component';
import { VisorPdfDocumentoModel } from 'src/app/models/common/VisorPdfDocumentoModel';

@Component({
  selector: 'app-validar-equipo-dialog',
  templateUrl: './validar-equipo-dialog.component.html',
  styleUrls: ['./validar-equipo-dialog.component.css']
})
export class ValidarEquipoDialogComponent implements OnInit {
  model!: ISolicitudEquipoModel;
  modelEquipo: ISolicitudEquipoValidarModel;
  displayedColumns: string[] = [
    'nombre',
    'idRequisito',
    'fechaVencimiento',
    'idDocumento',
    'aprobado',
    'observado'
  ];

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ValidarEquipoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EquipoModel,
    private solicitudEquipoService: SolicitudEquipoService,
    private solicitudEquipoDocumentoService: SolicitudEquipoDocumentosService,
    private alertDialogService: AlertDialogService,
  ) {
    this.model = new EquipoModel();
    this.modelEquipo = new SolicitudEquipoValidarModel();
  }

  ngOnInit(): void {
    this.solicitudEquipoService.getById(this.data.idSolicitud, this.data.idSolicitudEquipo).subscribe(p => {
      // console.log(p);      
      this.model = p;
      this.model.idSolicitud = this.data.idSolicitud;
      this.model.codigoSolicitud = this.data.codigoSolicitud;
      this.model.logs = this.model.logs.filter(p => p.comentarios != "" && p.comentarios != null);

      this.model.documentos.forEach((p) => {
        p.aprobado = p.idEstado === EstadoDocumentoItem.APROBADO;
        p.observado = p.idEstado === EstadoDocumentoItem.OBSERVADO;
      });

      this.modelEquipo.idSolicitudEquipo = this.data.idSolicitudEquipo;
      //this.modelEquipo.comentarios = this.data.comentarios;
      this.modelEquipo.idEstado = this.data.idEstado;
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  enviar() {
    let pendientes = this.model.documentos.filter(
      (p) => !p.aprobado && !p.observado
    ).length;

    let pendientesObservados = this.model.documentos.filter(
      (p) => p.observado
    ).length;

    if (pendientes == 0 && pendientesObservados >= 1 && (this.modelEquipo.comentarios == '' || !this.modelEquipo.comentarios)) {
      this.alertDialogService.open('Debe ingresar un comentario');
    } else {
      this.model.documentos.forEach(p => {
        let documento = new SolicitudDocumentoModel();
        documento.idDocumento = p.idSolicitudEquipoDocumento;
        if (p.aprobado) {
          documento.idEstado = EstadoDocumentoItem.APROBADO;
        }
        else if (p.observado) {
          documento.idEstado = EstadoDocumentoItem.OBSERVADO;
        }
        else {
          documento.idEstado = EstadoDocumentoItem.PENDIENTE;
        }

        this.modelEquipo.documentos.push(documento);
      });
      // console.log(this.modelEquipo);
      this.solicitudEquipoService.validar(this.modelEquipo).subscribe(p => {
        if (pendientes == 0) {
          if (pendientesObservados > 0)
            this.alertDialogService.open('Se registró su observación y se notificó al contratista');
          else
            this.alertDialogService.open('Se registró su aprobación');
          this.alertDialogService.closed().subscribe((confirmed) => {
            this.dialogRef.close(true);
          });
        }
        else
          this.dialogRef.close(true);
      });
    }
  }

  changeAprobado(element: DocumentacionRequeridaModel) {
    if (element.aprobado) element.observado = false;
  }

  changeObservado(element: DocumentacionRequeridaModel) {
    if (element.observado) element.aprobado = false;
  }

  downloadDocumentFromService(element: DocumentacionRequeridaModel) {
    if (element.permiteVisor) {
      let modelVisor: VisorPdfDocumentoModel = new VisorPdfDocumentoModel();
      modelVisor.seccion = SolicitudSeccion.Equipos;
      modelVisor.idRegistro = this.model.idSolicitudEquipo;
      modelVisor.idSolicitudDocumento = element.idSolicitudEquipoDocumento;
      modelVisor.codigoSolicitud = this.model.codigoSolicitud;
      modelVisor.nombreArchivo = element.nombreArchivo;
      const dialogVisroRef = this.dialog.open(VisorPdfDialogComponent, {
        width: '1300px',
        data: modelVisor,
        autoFocus: false,
      });
    }
    else {
      this.solicitudEquipoDocumentoService.downloadDocumento(
        this.model.codigoSolicitud,
        this.modelEquipo.idSolicitudEquipo,
        element.idSolicitudEquipoDocumento
      ).subscribe(data => {
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        fileSaver.saveAs(blob, element.nombreArchivo);
      });
    }
  }
}
